import React from "react";

import Container from "components/ThemedComponent/Common/Container";
import styled, { css } from "styled-components";
import { bp, bpMax, createStyleVariants } from "theme";

const JobCardsList = ({ children, isInternationalPage = false }) => (
	<Wrapper>
		<Container>
			<Grid isInternationalPage={isInternationalPage}>{children}</Grid>
		</Container>
	</Wrapper>
);

export default JobCardsList;

const Wrapper = styled.div`
	padding: 0;
	padding-bottom: 1.5rem;
`;

const GridVariants = createStyleVariants({
	apna: css`
		a {
		}
	`,
	vi: css`
		a {
			${bpMax.md} {
				&:first-child {
					border-top: none;
				}
			}
		}
	`,
});

const Grid = styled.div<{ isInternationalPage: Boolean }>`
	display: grid;
	grid-template-columns: repeat(1, minmax(0, 1fr));
	grid-gap: 12px;

	${({ isInternationalPage }) =>
		isInternationalPage &&
		css`
			grid-template-columns: repeat(1, minmax(0, 1fr));

			${bp.md} {
				grid-template-columns: repeat(2, minmax(0, 1fr));
			}
		`}

	${(props) => GridVariants(props.theme.vendor)}
`;
